import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ICartItem, IWatch } from 'Domain';

interface CartState {
  items: ICartItem[];
  reservationExpiry: number | null;
}

const initialState: CartState = {
  items: [],
  reservationExpiry: null,
};

const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    addToCart: (state, action: PayloadAction<IWatch>) => {
      const exists = state.items.find(item => item.watch.id === action.payload.id);
      if (!exists) {
        state.items.push({
          watch: action.payload,
          addedAt: Date.now(),
        });
      }
    },

    removeFromCart: (state, action: PayloadAction<string>) => {
      state.items = state.items.filter(item => item.watch.id !== action.payload);
    },

    clearCart: (state) => {
      state.items = [];
      state.reservationExpiry = null;
    },

    setReservationExpiry: (state, action: PayloadAction<number>) => {
      state.reservationExpiry = action.payload;
    },
  },
});

export const {
  addToCart,
  removeFromCart,
  clearCart,
  setReservationExpiry,
} = cartSlice.actions;

export default cartSlice.reducer;
